import React from "react";
import MyMessagesList from "./MyMessagesList";
import { MyMessagesContextImport } from "../../../../provider/work_profile/my_messages/MyMessagesContextProvider";
import { TextBlock } from "../../../../widget/common/ui/Text";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { Position } from "../../../../widget/common/ui/Stack";
import { IconCircleFilledIcon } from "../../../../widget/common/ui/Icon";
import AppTheme from "../../../../service/app_config/AppTheme";
import MyMessagesForm from "./MyMessagesForm";
import Div from "../../../../widget/common/ui/Div";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";

const MyMessagesAlert = (props: { fromChat?: boolean }) => {
  const type: number = ResponsiveDeviceType();
  const fromChat: boolean = props.fromChat ?? false;

  const {
    messageList,
    loadedStatus,
    tabName,
    selectedIds,
    selectedId,
    handleDeleteSubmit,
    handleDeleteCancel,
    handleTab,
    handleItemDelete,
    handleSubmit,
    handleClickMessage,
    handleClickToggleEdit,
    handleSendMessage,
    handleSendMessageOnceOff,
  } = MyMessagesContextImport();

  return (
    <>
      <div
        style={{ marginTop: fromChat && type !== 3 ? -15 : -30 }}
        className="position-relative"
      >
        <TextBlock
          maxLine={1}
          fontName="bold"
          textColor="theme-label"
          fontSize="20_21"
          //center={true}
          className="text-lg-center pt-2"
        >
          {AppTranslation.text("my_messages")}
        </TextBlock>
        {tabName === "none" && (
          <Position top={0} right={0} className="pe-4 d-flex">
            <IconCircleFilledIcon
              size={40}
              name="delete2"
              color="white"
              className="mx-2"
              bgColor="bgcolor-primary"
              wrapBgColor="bgcolor-primary"
              handleClick={() => handleTab("delete")}
            />

            <IconCircleFilledIcon
              name="plus"
              className="mx-2"
              size={40}
              color={AppTheme.white}
              handleClick={() => handleTab("add")}
            />
          </Position>
        )}
      </div>

      {["add"].includes(tabName) && (
        <MyMessagesForm
          handleCancel={handleDeleteCancel}
          handleSubmit={handleSubmit}
          handleSendMessage={handleSendMessageOnceOff}
          fromChat={fromChat}
        />
      )}
      {["none", "delete"].includes(tabName) && (
        <Div className="pb-0 pb-lg-4 px-0 pt-2">
          <MyMessagesList
            tabName={tabName}
            selectedIds={selectedIds}
            selectedId={selectedId}
            messageList={messageList}
            loadedStatus={loadedStatus}
            handleSubmit={handleDeleteSubmit}
            handleCancel={handleDeleteCancel}
            handleItemDelete={handleItemDelete}
            handleItemClick={handleClickMessage}
            handleClickToggleEdit={handleClickToggleEdit}
            handleSendMessage={handleSendMessage}
            fromChat={fromChat}
          />
        </Div>
      )}
    </>
  );
};

export default MyMessagesAlert;
